<ng-content select="app-control-page-card-header"></ng-content>

<div class="body">
  @if (expand) {
    <div [@expand]="expand.open ? 'open' : 'close'">
      <ng-content select="app-control-page-card-expanded"></ng-content>
    </div>

    <div [@expand]="expand.open ? 'close' : 'open'">
      <ng-content select="app-control-page-card-retracted"></ng-content>
    </div>
  }
  @else {
    <div>
      <ng-content select="app-control-page-card-expanded"></ng-content>
    </div>
  }
</div>